export { default } from './ImageListItemBar';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/ImageListItemBar/index.js
// module id = 832
// module chunks = 2